import { styles } from './template.scss';

export const templateGzDashboardApp = document.createElement('template');

templateGzDashboardApp.innerHTML = `
  <style>${styles}</style>

  <div class="wrapper">
  </div>
`;
